import { FormManager } from '@bark/bark-core/src/components/legacy-scripts/form-manager';
import { trackEmailPreferences, _t } from '@bark/bark-core';

export default function EmailSettings() {
	const formManager = FormManager();

	function Api() {
		var buyerNotificationOptions = [
			{
				label: _t('seller_settings_email-notifications:buyer-options.notify-emails'),
				id: 'mail_is_notify_emails',
				active: true,
				value: 0,
			},

			{
				label: _t('seller_settings_email-notifications:buyer-options.reminder-emails'),
				id: 'mail_is_reminder_emails',
				active: true,
				value: 0,
			},

			{
				label: _t('seller_settings_email-notifications:buyer-options.promo-emails'),
				id: 'mail_is_promo_emails',
				active: true,
				value: 0,
			},
		];
		var sellerNotificationOptions = [
			{
				label: _t('seller_settings_email-notifications:seller-options.new-client'),
				id: 'mail_new_client',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t('seller_settings_email-notifications:seller-options.buyer-closes-bark'),
				id: 'mail_buyer_closes_bark',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t('seller_settings_email-notifications:seller-options.buyer-dismisses'),
				id: 'mail_buyer_dismisses',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t('seller_settings_email-notifications:seller-options.buyer-hires'),
				id: 'mail_buyer_hires_you',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t('seller_settings_email-notifications:seller-options.buyer-response'),
				id: 'mail_buyer_reads_response',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t(
					'seller_settings_email-notifications:seller-options.buyer-request-call',
				),
				id: 'mail_buyer_request_call',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t(
					'seller_settings_email-notifications:seller-options.buyer-request-contact',
				),
				id: 'mail_buyer_request_contact',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t(
					'seller_settings_email-notifications:seller-options.buyer-views-profile',
				),
				id: 'mail_buyer_views_profile',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t(
					'seller_settings_email-notifications:seller-options.buyer-views-website',
				),
				id: 'mail_buyer_views_website',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t(
					'seller_settings_email-notifications:seller-options.buyer-views-contact-details',
				),
				id: 'mail_buyer_views_contact_details',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t('seller_settings_email-notifications:seller-options.daily-digest'),
				id: 'mail_daily_digest',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t('seller_settings_email-notifications:seller-options.new-message'),
				id: 'mail_new_message',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t('seller_settings_email-notifications:seller-options.new-review'),
				id: 'mail_new_review',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t(
					'seller_settings_email-notifications:seller-options.new-external-reviews',
				),
				id: 'mail_new_external_reviews',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t('seller_settings_email-notifications:seller-options.suggested'),
				id: 'mail_suggested',
				active: true,
				value: 0,
				hidden: false,
			},
			{
				label: _t('seller_settings_email-notifications:seller-options.promo-emails'),
				id: 'is_promo_emails',
				active: true,
				value: 0,
				hidden: false,
			},
		];
		var sendData = {
			seller: {},
			buyer: {},
		};
		var instanceVars = {
			addListenerToCheckbox: function (optionRow) {
				var checkbox = $('#option-toggle-' + optionRow.id);
				checkbox.on('change', function () {
					var checkbox = $(this);
					var usertype = checkbox.data('usertype');
					var id = $(this).prop('id').substr('option-toggle-'.length);
					var value = $(this).prop('checked');
					if (sendData[usertype].hasOwnProperty(id)) {
						delete sendData[usertype][id];
					} else {
						sendData[usertype][id] = value ? 1 : 0;
					}
					formManager.dirty(
						'email-notifications-' + usertype,
						!$.isEmptyObject(sendData[usertype]),
					);
				});
			},
			submitData: function (defer) {
				if (!$.isEmptyObject(sendData.seller)) {
					const trackingData = sendData.seller;
					Bark.api(
						'seller/notification/',
						sendData.seller,
						function (data) {
							sendData['seller'] = {};
							formManager.dirty('email-notifications-seller', false);
							trackEmailPreferences(trackingData, 'seller', true);
							defer.resolve();
						},
						function (err) {
							console.error(err.responseJSON, 'error!');
							modalManager.showError(
								_t('seller_settings_email-notifications:errors.update'),
							);
							trackEmailPreferences(trackingData, 'seller', false);
							defer.resolve();
						},
						'POST',
					);
				}
				if (!$.isEmptyObject(sendData.buyer)) {
					const trackingData = sendData.buyer;
					Bark.api(
						'buyer/notification/',
						sendData.buyer,
						function (data) {
							sendData['buyer'] = {};
							formManager.dirty('email-notifications-buyer', false);
							trackEmailPreferences(trackingData, 'buyer', true);
							defer.resolve();
						},
						function (err) {
							console.error(err.responseJSON, 'error!');
							modalManager.showError(
								_t('seller_settings_email-notifications:errors.update'),
							);
							trackEmailPreferences(trackingData, 'buyer', false);
							defer.resolve();
						},
						'POST',
					);
				}
			},
			cancelChanges: function () {
				Object.keys(sendData).forEach(function (usertype) {
					Object.keys(sendData[usertype]).forEach(function (checkboxId) {
						var checkboxEl = $('#option-toggle-' + checkboxId);
						checkboxEl.prop('checked', !sendData[usertype][checkboxId]);
					});
					sendData[usertype] = {};
					formManager.dirty('email-notifications-' + usertype, false);
				});
			},
			getNotificationOptions: function (forSeller, callBack) {
				if (forSeller) {
					Bark.api(
						'seller/self',
						{},
						function (data) {
							var notifications = data.data.notifications;
							var forDisplay = { options: [] };
							sellerNotificationOptions.map(function (currOpt, i, arr) {
								if (currOpt.id in notifications) {
									var hidey = currOpt.hidden ? ' d-none ' : '';
									var bg = i % 2 === 0 ? ' bg-light ' : ' bg-white ';
									var extras = hidey + bg;
									forDisplay.options.push({
										usertype: 'seller',
										id: currOpt.id,
										label: currOpt.label,
										active: currOpt.active,
										value: notifications[currOpt.id],
										hidden: currOpt.hidden,
										extra_class: extras,
									});
								}
							});
							callBack(forDisplay);
						},
						function (data) {
							callBack(false);
						},
					);
				} else {
					Bark.api(
						'buyer/self',
						{},
						function (data) {
							var notifications = data.data.mail_settings;
							var forDisplay = { options: [] };
							buyerNotificationOptions.map(function (currOpt) {
								var optionsReceived = notifications.filter(function (data) {
									return data.key === currOpt.id;
								});
								if (optionsReceived.length > 0) {
									forDisplay.options.push({
										usertype: 'buyer',
										id: currOpt.id,
										label: currOpt.label,
										active: currOpt.active,
										value: optionsReceived[0].value,
										hidden: currOpt.hidden,
									});
								}
							});
							callBack(forDisplay);
						},
						function (data) {
							callBack(false);
						},
					);
				}
			},
		};
		Object.assign(this, instanceVars);
	}
	var optionsLists = $('.notifications-options-list');
	var api = new Api();
	var template = $('#option-list').text();
	var render_template = Handlebars.compile(template);
	optionsLists.each(function (e) {
		var id = '' + $(this).prop('id');
		api.getNotificationOptions(id.startsWith('seller'), function (renderData) {
			if (renderData) {
				$('#' + id).html(render_template(renderData));
				renderData.options.map(api.addListenerToCheckbox);
				var formHandle =
					'email-notifications-' + (id.startsWith('seller') ? 'seller' : 'buyer');
				formManager.register(formHandle, api.submitData, api.cancelChanges);
			} else {
				$('#' + id).html(
					`<div class="text-danger alert alert-danger">${_t(
						'seller_settings_email-notifications:errors.fetch',
					)}</div>`,
				);
			}
			$('#' + id).removeClass('waiting');
		});
	});
}
